<template>
  <Layout>
    <div class="analysis-container">
      <PageHeader :title="title" :items="items" />
      <div v-if="obj" class="row">
        <div class="col-12">
          <div class="analysis-card-box">
            <b-tabs content-class="mt-3 rounded" pills>
              <b-tab title="Dados Principais" active pills>
                <div class="analysis-card-box-flexbox" v-if="!isClientDetailsOpened && !isSellerDetailsOpened">
                  <div class="analysis-card-box-flexbox--item">
                    <AnalysisTableClient :data="obj" :totalizer="countData" />
                  </div>
                  <div class="analysis-card-box-flexbox--item">
                    <AnalysisTableAddress :data="obj" :totalizer="countData" />
                  </div>
                  <div class="analysis-card-box-flexbox--item">
                    <AnalysisTableIp :data="obj" :totalizer="countData" />
                  </div>
                  <div class="analysis-card-box-flexbox--item">
                    <AnalysisTableSellData :status="status ? true : false" :analysis="dataAnalysis" :data="obj" :totalizer="countData" @accept="accept" @deny="deny"
                      @clientDetails="clientDetails" />
                  </div>
                  <div class="analysis-card-box-flexbox--item">
                    <AnalysisTableSeller :data="obj" :totalizer="countData" />
                  </div>
                  <div class="analysis-card-box-flexbox--item">
                    <AnalysisTableSell :data="obj" :totalizer="countData" @openModalProduct="openModalProduct" />
                  </div>
                  <div class="analysis-card-box-flexbox--item">
                    <AnalysisTableCard :data="obj" :totalizer="countData" />
                  </div>
                  <div class="analysis-card-box-flexbox--item">
                    <AnalysisTableSellerData :data="obj" :totalizer="countData" @sellerDetails="sellerDetails" />
                  </div>
                </div>
                <div class="analysis-card-box-flexbox-client client" v-if="isClientDetailsOpened">
                  <div class="title">
                    <svg fill="#000000" width="800px" height="800px" viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg" @click="clientDetails()">
                      <g data-name="Layer 2">
                        <g data-name="arrow-back">
                          <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
                          <path
                            d="M19 11H7.14l3.63-4.36a1 1 0 1 0-1.54-1.28l-5 6a1.19 1.19 0 0 0-.09.15c0 .05 0 .08-.07.13A1 1 0 0 0 4 12a1 1 0 0 0 .07.36c0 .05 0 .08.07.13a1.19 1.19 0 0 0 .09.15l5 6A1 1 0 0 0 10 19a1 1 0 0 0 .64-.23 1 1 0 0 0 .13-1.41L7.14 13H19a1 1 0 0 0 0-2z" />
                        </g>
                      </g>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="#3682F3">
                      <path
                        d="M22.6979 16.9214C22.6979 16.3691 22.2501 15.9214 21.6979 15.9214C21.1456 15.9214 20.6979 16.3691 20.6979 16.9214H22.6979ZM20.1057 21.6979V22.6979V21.6979ZM16.9214 20.6979C16.3691 20.6979 15.9214 21.1456 15.9214 21.6979C15.9214 22.2501 16.3691 22.6979 16.9214 22.6979V20.6979ZM16.9214 0C16.3691 0 15.9214 0.447715 15.9214 1C15.9214 1.55228 16.3691 2 16.9214 2V0ZM21.6979 2.59214H22.6979H21.6979ZM20.6979 5.77643C20.6979 6.32871 21.1456 6.77643 21.6979 6.77643C22.2501 6.77643 22.6979 6.32871 22.6979 5.77643H20.6979ZM0 5.77643C0 6.32871 0.447715 6.77643 1 6.77643C1.55228 6.77643 2 6.32871 2 5.77643H0ZM1 2.59214H0H1ZM2.59214 1V0V1ZM5.77643 2C6.32871 2 6.77643 1.55228 6.77643 1C6.77643 0.447715 6.32871 0 5.77643 0V2ZM5.77643 22.6979C6.32871 22.6979 6.77643 22.2501 6.77643 21.6979C6.77643 21.1456 6.32871 20.6979 5.77643 20.6979V22.6979ZM1 20.1057H0H1ZM2 16.9214C2 16.3691 1.55228 15.9214 1 15.9214C0.447715 15.9214 0 16.3691 0 16.9214H2ZM5.37839 10.1548H4.37839H5.37839ZM10.1548 5.37839V4.37839V5.37839ZM14.4443 13.03C14.0537 12.6395 13.4206 12.6395 13.03 13.03C12.6395 13.4206 12.6395 14.0537 13.03 14.4443L14.4443 13.03ZM16.2143 17.6285C16.6048 18.0191 17.238 18.0191 17.6285 17.6285C18.0191 17.238 18.0191 16.6048 17.6285 16.2143L16.2143 17.6285ZM20.6979 16.9214V20.1057H22.6979V16.9214H20.6979ZM20.6979 20.1057C20.6979 20.2628 20.6355 20.4134 20.5244 20.5244L21.9386 21.9386C22.4248 21.4525 22.6979 20.7932 22.6979 20.1057H20.6979ZM20.5244 20.5244C20.4134 20.6355 20.2628 20.6979 20.1057 20.6979V22.6979C20.7932 22.6979 21.4525 22.4248 21.9386 21.9386L20.5244 20.5244ZM20.1057 20.6979H16.9214V22.6979H20.1057V20.6979ZM16.9214 2H20.1057V0H16.9214V2ZM20.1057 2C20.2628 2 20.4134 2.06239 20.5244 2.17343L21.9386 0.759221C21.4525 0.273099 20.7932 0 20.1057 0V2ZM20.5244 2.17343C20.6355 2.28448 20.6979 2.4351 20.6979 2.59214H22.6979C22.6979 1.90466 22.4248 1.24534 21.9386 0.759221L20.5244 2.17343ZM20.6979 2.59214V5.77643H22.6979V2.59214H20.6979ZM2 5.77643V2.59214H0V5.77643H2ZM2 2.59214C2 2.4351 2.06239 2.28448 2.17343 2.17343L0.759221 0.759221C0.2731 1.24534 0 1.90466 0 2.59214H2ZM2.17343 2.17343C2.28448 2.06239 2.4351 2 2.59214 2V0C1.90466 0 1.24534 0.2731 0.759221 0.759221L2.17343 2.17343ZM2.59214 2H5.77643V0H2.59214V2ZM5.77643 20.6979H2.59214V22.6979H5.77643V20.6979ZM2.59214 20.6979C2.4351 20.6979 2.28448 20.6355 2.17343 20.5244L0.759221 21.9386C1.24534 22.4248 1.90466 22.6979 2.59214 22.6979V20.6979ZM2.17343 20.5244C2.06239 20.4134 2 20.2628 2 20.1057H0C0 20.7932 0.273099 21.4525 0.759221 21.9386L2.17343 20.5244ZM2 20.1057V16.9214H0V20.1057H2ZM4.37839 10.1548C4.37839 11.6868 4.98698 13.1561 6.07027 14.2394L7.48448 12.8252C6.77627 12.1169 6.37839 11.1564 6.37839 10.1548H4.37839ZM6.07027 14.2394C7.15356 15.3227 8.62282 15.9312 10.1548 15.9312V13.9312C9.15325 13.9312 8.1927 13.5334 7.48448 12.8252L6.07027 14.2394ZM10.1548 15.9312C11.6868 15.9312 13.1561 15.3227 14.2394 14.2394L12.8252 12.8252C12.1169 13.5334 11.1564 13.9312 10.1548 13.9312V15.9312ZM14.2394 14.2394C15.3227 13.1561 15.9312 11.6868 15.9312 10.1548H13.9312C13.9312 11.1564 13.5334 12.1169 12.8252 12.8252L14.2394 14.2394ZM15.9312 10.1548C15.9312 8.62282 15.3227 7.15356 14.2394 6.07027L12.8252 7.48448C13.5334 8.1927 13.9312 9.15325 13.9312 10.1548H15.9312ZM14.2394 6.07027C13.1561 4.98698 11.6868 4.37839 10.1548 4.37839V6.37839C11.1564 6.37839 12.1169 6.77627 12.8252 7.48448L14.2394 6.07027ZM10.1548 4.37839C8.62282 4.37839 7.15356 4.98698 6.07027 6.07027L7.48448 7.48448C8.1927 6.77627 9.15325 6.37839 10.1548 6.37839V4.37839ZM6.07027 6.07027C4.98698 7.15356 4.37839 8.62282 4.37839 10.1548H6.37839C6.37839 9.15325 6.77627 8.1927 7.48448 7.48448L6.07027 6.07027ZM13.03 14.4443L16.2143 17.6285L17.6285 16.2143L14.4443 13.03L13.03 14.4443Z"
                        fill="#3682F3" />
                    </svg>
                    <span class="section-title-client">Detalhes do cliente</span>
                  </div>
                  <div class="analysis-card-box-flexbox--item-client">
                    <ClientDetails :data="obj" :totalizer="countData" />
                  </div>
                  <div class="analysis-card-box-flexbox--item-client">
                    <ClientDetailsIp :data="obj" :totalizer="countData" />
                  </div>
                  <div class="analysis-card-box-flexbox--item-client">
                    <ClientDetailsCreditcard :data="obj" :totalizer="countData" />
                  </div>
                  <div class="analysis-card-box-flexbox--item-client">
                    <ClientDetailsSub :data="obj" :totalizer="countData" />
                  </div>
                  <div class="analysis-card-box-flexbox--item-client position-card">
                    <ClientDetailsEndereco :data="obj" :totalizer="countData" />
                  </div>
                  <div class="analysis-card-box-flexbox--item-client position-card">
                    <ClientDetailsEmail :data="obj" :totalizer="countData" />
                  </div>

                </div>
                <div class="analysis-card-box-flexbox-client" v-if="isSellerDetailsOpened">
                  <div class="title">
                    <svg fill="#000000" width="800px" height="800px" viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg" @click="sellerDetails()">
                      <g data-name="Layer 2">
                        <g data-name="arrow-back">
                          <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
                          <path
                            d="M19 11H7.14l3.63-4.36a1 1 0 1 0-1.54-1.28l-5 6a1.19 1.19 0 0 0-.09.15c0 .05 0 .08-.07.13A1 1 0 0 0 4 12a1 1 0 0 0 .07.36c0 .05 0 .08.07.13a1.19 1.19 0 0 0 .09.15l5 6A1 1 0 0 0 10 19a1 1 0 0 0 .64-.23 1 1 0 0 0 .13-1.41L7.14 13H19a1 1 0 0 0 0-2z" />
                        </g>
                      </g>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                      <path
                        d="M22.6979 16.9214C22.6979 16.3691 22.2501 15.9214 21.6979 15.9214C21.1456 15.9214 20.6979 16.3691 20.6979 16.9214H22.6979ZM20.1057 21.6979V22.6979V21.6979ZM16.9214 20.6979C16.3691 20.6979 15.9214 21.1456 15.9214 21.6979C15.9214 22.2501 16.3691 22.6979 16.9214 22.6979V20.6979ZM16.9214 0C16.3691 0 15.9214 0.447715 15.9214 1C15.9214 1.55228 16.3691 2 16.9214 2V0ZM21.6979 2.59214H22.6979H21.6979ZM20.6979 5.77643C20.6979 6.32871 21.1456 6.77643 21.6979 6.77643C22.2501 6.77643 22.6979 6.32871 22.6979 5.77643H20.6979ZM0 5.77643C0 6.32871 0.447715 6.77643 1 6.77643C1.55228 6.77643 2 6.32871 2 5.77643H0ZM1 2.59214H0H1ZM2.59214 1V0V1ZM5.77643 2C6.32871 2 6.77643 1.55228 6.77643 1C6.77643 0.447715 6.32871 0 5.77643 0V2ZM5.77643 22.6979C6.32871 22.6979 6.77643 22.2501 6.77643 21.6979C6.77643 21.1456 6.32871 20.6979 5.77643 20.6979V22.6979ZM1 20.1057H0H1ZM2 16.9214C2 16.3691 1.55228 15.9214 1 15.9214C0.447715 15.9214 0 16.3691 0 16.9214H2ZM5.37839 10.1548H4.37839H5.37839ZM10.1548 5.37839V4.37839V5.37839ZM14.4443 13.03C14.0537 12.6395 13.4206 12.6395 13.03 13.03C12.6395 13.4206 12.6395 14.0537 13.03 14.4443L14.4443 13.03ZM16.2143 17.6285C16.6048 18.0191 17.238 18.0191 17.6285 17.6285C18.0191 17.238 18.0191 16.6048 17.6285 16.2143L16.2143 17.6285ZM20.6979 16.9214V20.1057H22.6979V16.9214H20.6979ZM20.6979 20.1057C20.6979 20.2628 20.6355 20.4134 20.5244 20.5244L21.9386 21.9386C22.4248 21.4525 22.6979 20.7932 22.6979 20.1057H20.6979ZM20.5244 20.5244C20.4134 20.6355 20.2628 20.6979 20.1057 20.6979V22.6979C20.7932 22.6979 21.4525 22.4248 21.9386 21.9386L20.5244 20.5244ZM20.1057 20.6979H16.9214V22.6979H20.1057V20.6979ZM16.9214 2H20.1057V0H16.9214V2ZM20.1057 2C20.2628 2 20.4134 2.06239 20.5244 2.17343L21.9386 0.759221C21.4525 0.273099 20.7932 0 20.1057 0V2ZM20.5244 2.17343C20.6355 2.28448 20.6979 2.4351 20.6979 2.59214H22.6979C22.6979 1.90466 22.4248 1.24534 21.9386 0.759221L20.5244 2.17343ZM20.6979 2.59214V5.77643H22.6979V2.59214H20.6979ZM2 5.77643V2.59214H0V5.77643H2ZM2 2.59214C2 2.4351 2.06239 2.28448 2.17343 2.17343L0.759221 0.759221C0.2731 1.24534 0 1.90466 0 2.59214H2ZM2.17343 2.17343C2.28448 2.06239 2.4351 2 2.59214 2V0C1.90466 0 1.24534 0.2731 0.759221 0.759221L2.17343 2.17343ZM2.59214 2H5.77643V0H2.59214V2ZM5.77643 20.6979H2.59214V22.6979H5.77643V20.6979ZM2.59214 20.6979C2.4351 20.6979 2.28448 20.6355 2.17343 20.5244L0.759221 21.9386C1.24534 22.4248 1.90466 22.6979 2.59214 22.6979V20.6979ZM2.17343 20.5244C2.06239 20.4134 2 20.2628 2 20.1057H0C0 20.7932 0.273099 21.4525 0.759221 21.9386L2.17343 20.5244ZM2 20.1057V16.9214H0V20.1057H2ZM4.37839 10.1548C4.37839 11.6868 4.98698 13.1561 6.07027 14.2394L7.48448 12.8252C6.77627 12.1169 6.37839 11.1564 6.37839 10.1548H4.37839ZM6.07027 14.2394C7.15356 15.3227 8.62282 15.9312 10.1548 15.9312V13.9312C9.15325 13.9312 8.1927 13.5334 7.48448 12.8252L6.07027 14.2394ZM10.1548 15.9312C11.6868 15.9312 13.1561 15.3227 14.2394 14.2394L12.8252 12.8252C12.1169 13.5334 11.1564 13.9312 10.1548 13.9312V15.9312ZM14.2394 14.2394C15.3227 13.1561 15.9312 11.6868 15.9312 10.1548H13.9312C13.9312 11.1564 13.5334 12.1169 12.8252 12.8252L14.2394 14.2394ZM15.9312 10.1548C15.9312 8.62282 15.3227 7.15356 14.2394 6.07027L12.8252 7.48448C13.5334 8.1927 13.9312 9.15325 13.9312 10.1548H15.9312ZM14.2394 6.07027C13.1561 4.98698 11.6868 4.37839 10.1548 4.37839V6.37839C11.1564 6.37839 12.1169 6.77627 12.8252 7.48448L14.2394 6.07027ZM10.1548 4.37839C8.62282 4.37839 7.15356 4.98698 6.07027 6.07027L7.48448 7.48448C8.1927 6.77627 9.15325 6.37839 10.1548 6.37839V4.37839ZM6.07027 6.07027C4.98698 7.15356 4.37839 8.62282 4.37839 10.1548H6.37839C6.37839 9.15325 6.77627 8.1927 7.48448 7.48448L6.07027 6.07027ZM13.03 14.4443L16.2143 17.6285L17.6285 16.2143L14.4443 13.03L13.03 14.4443Z"
                        fill="#44A561" />
                    </svg>
                    <span>Detalhes do vendedor</span>
                    <div class="col text-center teste">
                    <b-button
                      variant="secondary"
                      class="float-right"
                      :disabled="!canViewRiskBigData || !!enriched_data"
                      v-b-tooltip.hover="!canViewRiskBigData ? 'Você não tem permissão para atualizar dados' : (enriched_data ? 'Dados já atualizados' : '')"
                      @click="getEnrichedData()"
                    >
                      Atualizar Dados
                    </b-button>
                  </div>
                  </div>
                  <b-row v-if="enriched_data">
                    <b-col lg="4">
                      <div>

                        <BasicEnrichment
                          :data="enriched_data"
                        />
                        
                      </div>
                    </b-col>
                    <b-col lg="4">
                      <div>

                        <personalEnrichment
                        :data="enriched_data"
                        />
                    
                      </div>
                    </b-col>
                    <b-col lg="4">
                      <div>

                        <complementaryEnrichment
                        :data="enriched_data"
                        />
                    
                       </div>
                    </b-col>
                  </b-row>
                  <div v-else class="card-not-data">
                    <div>
                      <h3>Sem dados Disponíveis</h3>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab v-if="!renderDetails" title="Detalhes da Compra">
                <detalheCompras 
                id="email"
                title="Compras com esse e-mail"
                icon="email"
                :data="dataEmail"
                :analyse="obj"
                type="email"
                />
               
                <detalheCompras 
                id="phone"
                title="Compras com esse telefone"
                icon="phone"
                :analyse="obj"
                type="cellphone"
                />

                <detalheCompras 
                :id="'ip'"
                title="Compras com esse Ip"
                icon="ip"
                :data="dataIp"
                :analyse="obj"
                type="ip"
                />

                <detalheCompras 
                id="visitor"
                title="Compras com esse Visitor"
                icon="visitor"
                :analyse="obj"
                type="fingerprint"
                />
               

                <!-- <div class="grid-tab">
                <div class="col-12 col-md-12">
                  <div v-if="obj.product && obj.product.seller">
                    <div class="externclass">
                      <div
                        class="classification"
                        :style="setColorCSS(obj.product.seller.classification)"
                      ></div>
                      <p><b>Nome vendedor:</b>{{ obj.product.seller.name }}</p>
                    </div>
                  </div>
                  <div v-if="obj.product && obj.product.seller"
                    ><b>E-mail vendedor:</b> {{ obj.product.seller.email }}</div
                  >
                  <div v-if="obj.product"
                    ><b>Celular vendedor:</b>
                    {{ obj.product.seller.cellphone }}</div
                  >
                  <div v-if="obj.product"
                    ><b>CPF vendedor:</b> {{ obj.product.seller.cpf_cnpj }}</div
                  >
                  <hr />
                  <div v-if="obj.client"
                    ><b>Nome cliente:</b
                    ><div
                      v-b-tooltip.hover
                      class="tags"
                      :class="setColor(count.name)"
                      title="Quantas vezes o nome foi utilizado"
                      >{{ count.name }}</div
                    >
                    {{ obj.client.name }}</div
                  >
                  <div v-if="obj.client"
                    ><b>E-mail cliente:</b>
                    <div
                      v-b-tooltip.hover
                      class="tags"
                      :class="setColor(count.email)"
                      title="Quantas vezes o e-mail foi utilizado"
                      >{{ count.email }}</div
                    >{{ obj.client.email }}</div
                  >
                  <div v-if="obj.client"
                    ><b>Celular cliente:</b>
                    <div
                      v-b-tooltip.hover
                      class="tags"
                      :class="setColor(count.phone)"
                      title="Quantas vezes o telefone foi utilizado"
                      >{{ count.phone }}</div
                    >
                    {{ obj.client.cellphone }}</div
                  >
                  <div v-if="obj.client"
                    ><b>CPF cliente:</b>
                    <div
                      v-b-tooltip.hover
                      class="tags"
                      :class="setColor(count.cpf_cnpj)"
                      title="Quantas vezes o Documento foi utilizado"
                      >{{ count.cpf_cnpj }}</div
                    >
                    {{ obj.client.cpf_cnpj }}</div
                  >
                  <hr />
                  <div v-if="obj.product"
                    ><b>Produto:</b> {{ obj.product.name }}</div
                  >
                  <div><b>Valor:</b> R$ {{ formatMoney(obj.total) }}</div>
                  <div v-if="obj.method"
                    ><b>Método:</b>
                    <div
                      v-if="obj.method === 'CREDIT_CARD'"
                      v-b-tooltip.hover
                      class="tags"
                      :class="setColor(count.card)"
                      title="Quantas vezes o cartão foi utilizado"
                      >{{ count.card }}</div
                    >{{
                      obj.method === 'CREDIT_CARD'
                        ? 'Cartão de crédito'
                        : obj.method
                    }}</div
                  >
                  <div v-if="obj.paid_at"
                    ><b>Data:</b> {{ obj.paid_at | datetime }}</div
                  >
                  <a
                    class="link pointer"
                    rel="noopener noreferrer"
                    @click="openModalProduct(obj)"
                    >Ver Produto</a
                  >
                  <hr />
                  <div><b>Razão:</b> {{ obj.reason }}</div>
                </div>

                <div>
                  <b>Dados da compra e localização - Score, Body</b>
                  <div v-if="obj.risk_score"
                    ><b>Classificação de Risco:</b> {{ obj.risk_score }}</div
                  >
                  <hr v-if="obj.risk_body" />
                  <div
                    v-if="
                      obj.risk_body && ipAddress && city
                    "
                    ><b>Nome da Cidade:</b>
                    {{ ipAddress.city.names['pt-BR'] }}</div
                  >
                  <div
                    v-if="
                      obj.risk_body &&
                      ipAddress &&
                      subdivisions
                    "
                    ><b>Estado:</b>
                    {{ ipAddress.subdivisions[0].names['pt-BR'] }}</div
                  >
                  <div
                    v-if="
                      obj.risk_body &&
                      obj.risk_body.ip_address &&
                      registeredCountry
                    "
                    ><b>Pais:</b>
                    {{ ipAddress.registered_country.names['pt-BR'] }}</div
                  >
                  <div
                    v-if="
                      obj.risk_body &&
                      ipAddress &&
                      continent
                    "
                    ><b>Continente:</b>
                    {{ ipAddress.continent.names['pt-BR'] }}</div
                  >
                  <hr v-if="obj.risk_body" />
                  <div v-if="obj.risk_body && ipAddress"
                    ><b>Endereço de IP:</b>
                    <div
                      v-b-tooltip.hover
                      class="tags"
                      :class="setColor(count.ip)"
                      title="Quantas vezes o IP foi utilizado"
                      >{{ count.ip }}</div
                    >
                    {{ ipAddress.traits.ip_address }}</div
                  >
                  <div v-if="obj.risk_body && ipAddress"
                    ><b>Fornecedor de Internet:</b>
                    {{ ipAddress.traits.isp }}</div
                  >
                  <hr v-if="obj.risk_body" />
                  <div v-if="obj.risk_body && ipAddress && location"
                    ><b>Latitude:</b> {{ ipAddress.location.latitude }}</div
                  >
                  <div v-if="obj.risk_body && ipAddress && location"
                    ><b>Longitude:</b> {{ ipAddress.location.longitude }}</div
                  >
                  <div v-if="obj.risk_body && ipAddress && location"
                    ><a
                      :href="
                        'https://www.google.com/maps/search/?api=1&query=' +
                        ipAddress.location.latitude +
                        ',' +
                        ipAddress.location.longitude
                      "
                      target="_blank"
                      rel="noopener noreferrer"
                      >Ver no Google Maps</a
                    ></div
                  >
                  <hr />
                  <div v-if="obj.risk_body === null"> Sem Dados de Risco </div>
                  <div v-if="obj.risk_body">
                    <b-button
                      v-if="!jsonList"
                      rel="noopener noreferrer"
                      variant="success"
                      @click="toggleJSON"
                      >Ver JSON completo</b-button
                    ><b-button
                      v-if="jsonList"
                      rel="noopener noreferrer"
                      variant="success"
                      @click="toggleJSON"
                      >Fechar JSON</b-button
                    ></div
                  >
                  <JsonViewer
                    v-if="jsonList && obj.risk_body"
                    :value="obj.risk_body"
                  />
                </div>
              </div> -->
              </b-tab>
              <!-- <b-tab title="Dados Enriquecidos">
                

              </b-tab> -->
            </b-tabs>
            <!-- <div v-if="loading" class="row justify-content-center">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div> -->
            <ModalDetails
              v-if="canShowProductHistory && !!productId"
              :data="dataUser"
              :type="stateToProduct"
              :product-id="productId"
            />
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>

<script>
import Money from '@src/mixins/money'
import JsonViewer from 'vue-json-viewer'
import ModalDetails from '../../../router/views/products/modal-details.vue'
import AnalysisService from '@services/resources/AnalysisService'
import MessagesService from '@services/resources/MessagesService'
import PageHeader from '@components/page-header'
import Layout from '@layouts/main'
import ViewRisk from '@components/analysis/view-risk'
import AnalysisTableClient from '@components/common/analysis-table/client.vue'
import AnalysisTableAddress from '@components/common/analysis-table/address.vue'
import AnalysisTableIp from '@components/common/analysis-table/ip.vue'
import AnalysisTableSeller from '@components/common/analysis-table/seller.vue'
import AnalysisTableSell from '@components/common/analysis-table/sell.vue'
import AnalysisTableCard from '@components/common/analysis-table/card.vue'
import AnalysisTableSellData from '@components/common/analysis-table/sell-data.vue'
import AnalysisTableSellerData from '@components/common/analysis-table/seller-data.vue'
import ClientDetails from '@components/common/analysis-table/client-details.vue'
import ClientDetailsIp from '@components/common/analysis-table/client-details-ip.vue'
import ClientDetailsCreditcard from '@components/common/analysis-table/client-details-credit-card.vue'
import ClientDetailsSub from '@components/common/analysis-table/client-details-sub.vue'
import ClientDetailsEndereco from '@components/common/analysis-table/client-detail-endereco-cobranca.vue'
import ClientDetailsEmail from '@components/common/analysis-table/client-detail-email.vue'
import BasicEnrichment from "@/src/components/common/analysis-table/basicEnrichment.vue";
import personalEnrichment from "@/src/components/common/analysis-table/personalEnrichment.vue";
import complementaryEnrichment from "@/src/components/common/analysis-table/complementaryEnrichment.vue";

import Vue from 'vue'
import detalheCompras from '@/src/components/detalheCompras.vue'
import {AccessLevel} from "@views/configurations/enums/accessLevel";

const serviceMessage = MessagesService.build()
const service = AnalysisService.build()

export default {
  name: 'ViewAnalyse',
  components: { JsonViewer, ModalDetails, PageHeader, Layout, ViewRisk, AnalysisTableClient, AnalysisTableAddress, AnalysisTableIp, AnalysisTableSeller, AnalysisTableSell, AnalysisTableCard, AnalysisTableSellData, AnalysisTableSellerData, ClientDetails, ClientDetailsIp, ClientDetailsCreditcard, ClientDetailsSub, ClientDetailsEndereco, ClientDetailsEmail, detalheCompras, BasicEnrichment, personalEnrichment, complementaryEnrichment },
  mixins: [Money],
  props: {
    id: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      renderDetails: false,
      dataIp: [],
      dataPhone: [],
      dataFingerPrint: [],
      dataEmail: [],
      isClientDetailsOpened: false,
      isSellerDetailsOpened: false,
      title: 'Análise da venda',
      items: [
        { text: 'Início', href: '/' },
        { text: 'Análise de Risco', active: true }
      ],
      loading: false,
      currentPage: 1,
      totalRows: 1,
      stateToProduct: 'analisy',
      jsonList: false,
      users: [],
      dataUser: {},
      analysis: [],
      messages: [],
      sortBy: 'name',
      sortDesc: false,
      fields: [
        { key: 'transaction_id', label: 'ID Pagarme', sortable: true },
        { key: 'id', label: 'ID Greenn', sortable: true },
        { key: 'created_at', label: 'Data', sortable: false },
        { key: 'type', label: 'Tipo', sortable: true },
        { key: 'status', label: 'Status', sortable: false },
        { key: 'total', label: 'Valor Greenn', sortable: true },
        { key: 'method', label: 'Método', sortable: false },
        { key: 'fee', label: 'Antecipação', sortable: false },
      ],
      fieldsMessages: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'created_at', label: 'Data' },
        { key: 'type', label: 'Tipo' },
        { key: 'title', label: 'Titulo' },
        { key: 'system', label: 'Sistema' },
        { key: 'to_address', label: 'E-mail' },
        { key: 'email_click_count', label: 'Click E-mail' },
        { key: 'whatsapp_click_count', label: 'Click Whats' },
        { key: 'to_name', label: 'Detalhes' },
      ],
      typeAnalysis: 'email',
      teste1: 0.13,
      count: null,
      status:"",
      dataAnalysis: {},
      obj: {
        product: {
          seller: {},
        },
        id: '45dd9a68-a360-4d7e-84ee-aceeeba64393',
        email: {
          domain: { first_seen: '2019-01-01' },
          is_free: true,
          first_seen: '2021-10-05',
          is_high_risk: false,
          is_disposable: false,
        },
        ip_address: {
          city: {
            names: {
              de: 'Niterói',
              en: 'Niterói',
              es: 'Niterói',
              fr: 'Niterói',
              ja: 'ニテロイ',
              ru: 'Нитерой',
              'pt-BR': 'Niterói',
            },
            confidence: 90,
            geoname_id: 3456283,
          },
          risk: 0.01,
          postal: { code: '24000', confidence: 1 },
          traits: {
            isp: 'Claro NET',
            domain: 'virtua.com.br',
            network: '186.223.183.64/26',
            user_type: 'residential',
            ip_address: '186.223.183.105',
            organization: 'Claro NET',
            static_ip_score: 23.8,
            autonomous_system_number: 28573,
            autonomous_system_organization: 'CLARO S.A.',
          },
          country: {
            names: {
              de: 'Brasilien',
              en: 'Brazil',
              es: 'Brasil',
              fr: 'Brésil',
              ja: 'ブラジル連邦共和国',
              ru: 'Бразилия',
              'pt-BR': 'Brasil',
              'zh-CN': '巴西',
            },
            iso_code: 'BR',
            confidence: 99,
            geoname_id: 3469034,
            is_high_risk: false,
          },
          location: {
            latitude: -22.9201,
            longitude: -43.0811,
            time_zone: 'America/Sao_Paulo',
            local_time: '2021-10-05T20:39:12-03:00',
            accuracy_radius: 10,
          },
          continent: {
            code: 'SA',
            names: {
              de: 'Südamerika',
              en: 'South America',
              es: 'Sudamérica',
              fr: 'Amérique du Sud',
              ja: '南アメリカ',
              ru: 'Южная Америка',
              'pt-BR': 'América do Sul',
              'zh-CN': '南美洲',
            },
            geoname_id: 6255150,
          },
          subdivisions: [
            {
              names: {
                en: 'Rio de Janeiro',
                es: 'Río de Janeiro',
                'pt-BR': 'Rio de Janeiro',
              },
              iso_code: 'RJ',
              confidence: 99,
              geoname_id: 3451189,
            },
          ],
          registered_country: {
            names: {
              de: 'Brasilien',
              en: 'Brazil',
              es: 'Brasil',
              fr: 'Brésil',
              ja: 'ブラジル連邦共和国',
              ru: 'Бразилия',
              'pt-BR': 'Brasil',
              'zh-CN': '巴西',
            },
            iso_code: 'BR',
            geoname_id: 3469034,
          },
        },
        risk_score: 1.55,
        credit_card: {
          type: 'credit',
          brand: 'Mastercard',
          issuer: { name: 'Santander' },
          country: 'BR',
          is_prepaid: false,
          is_virtual: false,
          is_business: false,
          is_issued_in_billing_address_country: true,
        },
        billing_address: {
          latitude: -23.5477,
          longitude: -46.6358,
          is_in_ip_country: true,
          distance_to_ip_location: 370,
        },
        funds_remaining: 4.355,
        queries_remaining: 290,
      },
      enriched_data: null,
    }
  },
  computed: {
    canShowProductHistory() {
      return this.$canAction('products_show_change_history', AccessLevel.READER);
    },
    risk_body() {
      return this.obj.risk_body
    },
    billing_address() {
      return this.obj.risk_body.billing_address
    },
    ipAddress() {
      return this.obj.risk_body.ip_address
    },
    credit_card() {
      return this.obj.risk_body.credit_card
    },
    device() {
      return this.obj.risk_body.device
    },
    email() {
      return this.obj.risk_body.email
    },
    city() {
      return this.obj.risk_body.ip_address.city;
    },
    continent() {
      return this.obj.risk_body.ip_address.continent
    },
    country() {
      return this.obj.risk_body.ip_address.country
    },
    location() {
      return this.obj.risk_body.ip_address.location
    },
    registeredCountry() {
      return this.obj.risk_body.ip_address.registered_country
    },
    subdivisions() {
      return this.obj.risk_body.ip_address.subdivisions
    },
    countData() {
      return this.count
    },
    productId() {
      return this.obj && this.obj.product && this.obj.product.id ? this.obj.product.id : null;
    },
    canViewRiskBigData() {
      return this.$canAction('risk_analysis_show_big_data', AccessLevel.READER)
    },
  },

  watch: {
    currentPage() {
      this.fetchUsers()
    },
  },

  async mounted() {
    this.loading = true
    await this.fetchSaleAnalysis();
  },
  methods: {
    async fetchSaleAnalysis(){
      this.setDynamicLoad('selldata', true)

      await service
      .read(this.$route.params.id + '/sale')
      .then((resp) => {
        resp.data.risk_body = JSON.parse(resp.data.risk_body)
        this.obj = resp.data
        this.status = resp.analyse.status
        this.dataAnalysis = resp.analyse
        this.enriched_data = resp.enriched_data
        this.count = resp.totalizer
        this.loading = false
      })
      .catch((err) => {
        console.log(err)
      }).finally(() => {
        this.setDynamicLoad('selldata', false)
      })
    },
    tabs(a) {
      if (a === 'emails' || a === 'mensage') {
        this.typeAnalysis = a
        this.fetchMenssages()
        return
      }
    },
    setColor(number) {
      if (number === 1 || number === 0) {
        return ''
      } else if (number > 2 && number < 5) {
        return 'aberto'
      } else if (number >= 5) {
        return 'fraude'
      } else {
        return ''
      }
    },
    async update(data) {
      await service
        .update(data)
        .then(() => {
          this.status = true;
          this.$bvModal.hide('modal-view')
        })
        .catch(err => console.error(err))
    },
    async setAsAlarm(data) {
      await service
        .update(data)
        .then(async(response) => {
          if (response.success) {
            await this.fetchSaleAnalysis();
            this.reloadDetails();
          } else {
            Vue.swal({ html: `Ocorreu um erro!` });
          }
        })
        .catch(err => {
          Vue.swal({ html: `Ocorreu um erro!` });
          console.error(err)
        })
    },
    async setAsFraud(data) {
      await service
        .update(data)
        .then(async (response) => {
          if (response.success) {
            await this.fetchSaleAnalysis();
            this.reloadDetails();
          } else {
            Vue.swal({ html: `Ocorreu um erro!` });
          }
        })
        .catch(err => {
          Vue.swal({ html: `Ocorreu um erro!` });
          console.error(err)
        })
    },
    async accept(id) {
      Vue.swal({
        title: 'Análise',
        text: 'Tem certeza que deseja reportar como Alarme Falso? A venda continuará no Greenn.',
        type: 'success',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off',
        },
        inputValidator: (value) => {
          if (value && value.length <= 10) {
            return "O motivo da fraude deve ter mais de 10 caracteres!";
          }
        }
      }).then(async(result) => {
        if (result.value) {
         await this.setAsAlarm({ id, status: 'FALSE_ALARM', fraud_reason: result.value })
        }
      })
    },

    async deny(id) {
      await Vue.swal({
        title: "Análise",
        text: "Tem certeza que deseja reportar como Fraude? A venda será reembolsada no Greenn.",
        type: 'error',
        input: "text",
        inputPlaceholder: 'Motivo da fraude',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        inputValidator: (value) => {
          if (value && value.length <= 10) {
            return "O motivo da fraude deve ter mais de 10 caracteres!";
          }
        }
      }).then(async(result) => {
        if (result.value) {
          await this.setAsFraud({ id, status: 'FRAUD', fraud_reason: result.value })
        }
      });
    },

    fetchMenssages() {
      this.loading = true;
      this.messages = [];
      this.analysis = [];

      let data = {
        page: this.currentPage,
        to_address: this.obj.client.email,
      }

      serviceMessage
        .search(data)
        .then((resp) => {
          this.messages = resp.data
          this.currentPage = resp.current_page
          this.totalRows = resp.last_page
          this.loading = false
        })
    },

    setColorCSS(type) {
      if (type) {
        if (type === 'green') return 'background: #00E4A0'
        if (type === 'yellow') return 'background: #fff700'
        if (type === 'red') return 'background: #FF0A44'
        if (type === 'black') return 'background: #000000'

      } else {
        return 'background:#c7c7c7;'
      }
    },
    setDynamicLoad(type, value) {
      let field = type.charAt(0).toUpperCase() + type.slice(1)
      
      return this.$store.dispatch(`updateLoadingAnalysis${field}`, value);
    },
    reloadDetails(){
      this.renderDetails = true;
      this.$nextTick(() => {
        this.renderDetails = false;
      });
    },
    openModalProduct() {
      if (!this.canShowProductHistory) {
        return;
      }
      if (!this.obj || !this.obj.product || !this.obj.product.id) {
        return;
      }
      this.dataUser = this.obj.product;
      this.$bvModal.show('details');
    },
    toggleJSON() {
      if (this.jsonList) {
        this.jsonList = false
      } else {
        this.jsonList = true
      }
    },
    getEnrichedData() {
      this.loading = true
      service
        .read('/big-data/' + this.$route.params.id)
        .then((resp) => {
          this.enriched_data = resp.data;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        })
    },
    clientDetails() {
      this.isClientDetailsOpened = !this.isClientDetailsOpened
    },
    sellerDetails() {
      this.isSellerDetailsOpened = !this.isSellerDetailsOpened
    }
  },


}
</script>

<style lang="scss" scoped>
table {
  min-width: 100%;
  border-radius: 5px;
}

td,
th {
  border: 1px solid #ddd;
  text-align: left;
  padding: 8px;
}

th {
  background-color: #f0faf0;
}

.button-action {
  width: 35px;
  height: 35px;
  background: rgba(33, 51, 210, 0.1);
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.tags {
  padding: 3px 5px;
  text-align: center;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0.2px;
  border-radius: 2px;
  background: #f7f7f7;
  color: #333333;
  height: fit-content;
  margin: 0 5px;
  display: inline-block;
}

.aberto {
  color: #2133d2 !important;
  background: rgba(33, 51, 210, 0.1) !important;
}

.fraude {
  color: #f41a42 !important;
  background: rgba(244, 26, 66, 0.1) !important;
}

.alarme {
  color: #ff9900 !important;
  background: rgba(255, 153, 0, 0.1) !important;
}

.pointer {
  cursor: pointer;
}

.analysis-container {
  margin: 10px 0px;
  background-color: white;
  border-radius: .25rem;
  padding: 10px 20px;
}

.analysis-card-box {
  background-color: #fff;
  margin-bottom: 24px;
  border-radius: .25rem;
}

.analysis-card-box-flexbox {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  padding: 0;
  margin: 0;
  list-style: none;

}

.analysis-card-box-flexbox--item {
  background: #fff;
  width: 24%;
  height: 370px;
  margin-top: 10px;
  border-radius: 15px;
  border: 1px solid #E5E5E5;
}

.analysis-card-box-flexbox-client {
  flex-flow: row wrap;
  justify-content: flex-start;
  padding: 0;
  margin: 0;
  list-style: none;
  align-items: flex-start;
  height: auto;
}

.analysis-card-box-flexbox--item-client {
  background: #fff;
  width: 24%;
  height: auto;
  margin-top: 10px;
  border-radius: 15px;
  border: 1px solid #E5E5E5;
  margin-right: 10px;
  position:relative;
}

.analysis-card-box-flexbox--item-client:nth-child(4) {
  margin-right: 0px
}

@media (max-width: 1024px) {
  .analysis-card-box-flexbox--item-client {
    background: #fff;
    width: 100%;
    height: auto;
    margin-top: 10px;
    border-radius: 15px;
    border: 1px solid #E5E5E5;
  }
}

@media (max-width: 1024px) {
  .analysis-card-box-flexbox--item {
    background: #fff;
    width: 100%;
    height: auto;
    margin-top: 10px;
    border-radius: 15px;
    border: 1px solid #E5E5E5;
  }

}

.analysis-card-box-flexbox--item:nth-child(4),
.analysis-card-box-flexbox--item:nth-child(8) {
  width: 24%;
  height: auto;
  margin-top: 10px;
  border-radius: 15px;
  border: none;
}

@media (max-width: 1024px) {

  .analysis-card-box-flexbox--item:nth-child(4),
  .analysis-card-box-flexbox--item:nth-child(8) {
    background: #fff;
    width: 100%;
    height: auto;
    margin-top: 10px;
    border-radius: 15px;

  }

}

.title {
  width: 100%;
  height: 20px;
  display: flex;
  margin-bottom: 40px;
}

.title svg {
  width: 20px;
  height: 20px;
  margin: 0px 5px;
  cursor: pointer;
}

.title span {
  color: #44A561;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  margin: 0px 5px;

}

.float-right {
  background: #003675;
  padding: 16px;
  border-radius: 8px;

  &:disabled{
    opacity: 0.3;
    cursor: not-allowed;
  }
}

.position-card {
  position: relative;
  top: -230px;
}

.card-not-data {
  border: 1px solid #c1c1c167;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 100px;
  padding: 20px;
  border-radius: 20px;
   h3{
    color: #939292;
   }
}

.client {
  display: flex;
}

.section-title-client {
  color: #3682F3 !important;
}

.teste{
  position: relative;
  bottom: 20px;
}
</style>
